<template>
  <div class="section-arrow">
    <span class="section-arrow__icon">↓</span>
  </div>
</template>

<script>
export default {
  name: 'SectionArrow',
}
</script>

<style scoped>
.section-arrow {
  display: none;
  justify-content: center;
  padding: 8px 0;
}

.section-arrow__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-white);
  color: var(--color-text-light);
  font-size: 14px;
  box-shadow: var(--shadow-card);
}

@media (min-width: 768px) {
  .section-arrow {
    display: flex;
  }
}
</style>
